import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { updateShowModal } from "../../../../redux/message/messageSlice";
import { AppDispatch } from "../../../../redux/store";
import { PremiumModal } from "../PremiumModal";

export const EaSquadImportLinkModal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  return (
    <PremiumModal
      title="Club Import in Squad Builder requires an Ultimate Subscription"
      content="EA has recently removed the 'Share Squad with EA Link' functionality. You can still import your squad with an Ultimate Subscription using club import."
      onPositiveButtonClicked={() => {
        navigate("subscription");
        dispatch(updateShowModal({ modalType: "none" }));
      }}
      onCloseClicked={() => {
        dispatch(updateShowModal({ modalType: "none" }));
      }}
      positiveActionButtonLabel="Go to Subscriptions"
      negativeActionButtonLabel="Cancel"
    />
  );
};
